import { render, staticRenderFns } from "./SmsVerifyPhoneOtp.vue?vue&type=template&id=2f9963e0&scoped=true"
import script from "./SmsVerifyPhoneOtp.vue?vue&type=script&lang=js"
export * from "./SmsVerifyPhoneOtp.vue?vue&type=script&lang=js"
import style0 from "./SmsVerifyPhoneOtp.vue?vue&type=style&index=0&id=2f9963e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9963e0",
  null
  
)

export default component.exports